import { ListItemButton as NovaBaseListItemButton } from '@fme-nova/components'
import { default as MuiBaseListItemButton, ListItemButtonProps } from '@mui/material/ListItemButton'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiListItemButton: MsdkStyledComponent<ListItemButtonProps> = styled(MuiBaseListItemButton)`
  &:hover {
    background-color: ${COLORS.action.hover};
  }
  &:disabled {
    color: ${COLORS.text.disabled};
  }
  &:visited {
    color: ${COLORS.text.primary};
  }
  &:active {
    background-color: ${COLORS.primary.selected};
  }
  &:focus {
    background-color: ${COLORS.action.focus};
  }
`

const NovaListItemButton: MsdkStyledComponent<ListItemButtonProps> = styled(NovaBaseListItemButton)`
  &:hover {
    background-color: ${COLORS.action.hover};
  }
  &:disabled {
    color: ${COLORS.text.disabled};
  }
  &:visited {
    color: ${COLORS.text.primary};
  }
  &:active {
    background-color: ${COLORS.primary.selected};
  }
  &:focus {
    background-color: ${COLORS.action.focus};
  }
`

export const ListItemButton = createComponentWrapperWithRef<ListItemButtonProps | any>(
  {
    mui: MuiListItemButton,
    nova: NovaListItemButton,
  },
  'ListItemButton',
)
